<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38.353"
    height="34.998"
    viewBox="0 0 38.353 34.998"
  >
    <g id="组_993" data-name="组 993" transform="translate(-68.175 -100.4)">
      <path
        id="路径_359"
        data-name="路径 359"
        d="M99.788,135.4H74.911a6.725,6.725,0,0,1-5.824-10.088l12.44-21.545a6.729,6.729,0,0,1,11.656,0l12.432,21.541A6.729,6.729,0,0,1,99.788,135.4ZM87.352,104.223a2.874,2.874,0,0,0-2.514,1.45L72.4,127.218a2.9,2.9,0,0,0,2.514,4.353H99.788a2.9,2.9,0,0,0,2.514-4.353l-12.44-21.545A2.867,2.867,0,0,0,87.352,104.223Zm-4.171.5h0Z"
        transform="translate(0 0)"
        fill="#fff"
      />
      <path
        id="路径_360"
        data-name="路径 360"
        d="M471.953,663.853m-2.153,0a2.153,2.153,0,1,0,2.153-2.153A2.153,2.153,0,0,0,469.8,663.853Z"
        transform="translate(-384.601 -537.508)"
        fill="#fff"
      />
      <path
        id="路径_361"
        data-name="路径 361"
        d="M477.412,404.056a1.912,1.912,0,0,1-1.912-1.912v-5.832a1.912,1.912,0,1,1,3.823,0v5.832A1.912,1.912,0,0,1,477.412,404.056Z"
        transform="translate(-390.06 -281.538)"
        fill="#fff"
      />
    </g>
  </svg>
</template>
